var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBottomtabActivityActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9225 2.23105C17.7992 2.12856 17.6531 2.05721 17.4965 2.02301C17.3399 1.98882 17.1773 1.99278 17.0225 2.03457C16.8678 2.07636 16.7253 2.15474 16.6072 2.26312C16.489 2.3715 16.3987 2.50669 16.3438 2.6573L13.5938 10.2085L10.5737 7.2823C10.4723 7.18393 10.3512 7.10817 10.2184 7.06001C10.0856 7.01185 9.94403 6.99238 9.80313 7.00289C9.66223 7.01341 9.52516 7.05365 9.40095 7.12099C9.27674 7.18833 9.1682 7.28122 9.0825 7.39355C6.375 10.941 5 14.5098 5 17.9998C5 20.9172 6.15893 23.7151 8.22183 25.778C10.2847 27.8409 13.0826 28.9998 16 28.9998C18.9174 28.9998 21.7153 27.8409 23.7782 25.778C25.8411 23.7151 27 20.9172 27 17.9998C27 10.5685 20.6513 4.4998 17.9225 2.23105Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBottomtabActivityActive);
export default __webpack_public_path__ + "static/media/icon_bottomtab_activity_active.2bcf25be8a53e978c2cf9ae7d93caeca.svg";
export { ForwardRef as ReactComponent };